import moment from "moment";
import { LicenseModuleEnum } from "./LicenseModuleEnum";
import { LicenseModuleStatusEnum } from "./LicenseModuleStatusEnum";
import { LicenseStatusEnum } from "./LicenseStatusEnum";

export const stretchingWindowBeforeExpiration = 15;
export const stretchingWindowAfterExpiration = 15;

export class LicenseModule {
    module: LicenseModuleEnum;
    expirationDate: Date;
    nDevices: number;
    status: LicenseStatusEnum;

    getStatus(): LicenseModuleStatusEnum {
        switch (this.status) {
            case LicenseStatusEnum.Perpetual:
                return LicenseModuleStatusEnum.Valid;
            case LicenseStatusEnum.NotEnabled:
            case LicenseStatusEnum.Expired:
            case LicenseStatusEnum.VersionNotEnabled:
                return LicenseModuleStatusEnum.Expired;
            case LicenseStatusEnum.Demo: {
                const now = moment();
                const expiration = moment(this.expirationDate);

                const daysDiff = expiration.diff(now, "days");
                if (daysDiff > 0) {
                    // deve ancora scadere
                    if (daysDiff > stretchingWindowBeforeExpiration) return LicenseModuleStatusEnum.Valid;
                    else return LicenseModuleStatusEnum.CloseToExpiration;
                } else {
                    // è scaduta
                    if (Math.abs(daysDiff) > stretchingWindowAfterExpiration) return LicenseModuleStatusEnum.Expired;
                    else return LicenseModuleStatusEnum.ExpiredRecently;
                }
            }
        }
    }

    isAvailable(): boolean {
        return this.getStatus() != LicenseModuleStatusEnum.Expired && this.nDevices > 0;
    }

    isExpired(): Boolean {
        return new Date() < this.expirationDate;
    }

    getExpirationDateDiff(): number {
        const now = moment();
        const expiration = moment(this.expirationDate);

        return expiration.diff(now, "days");
    }
}
